import { Suspense } from 'react';
import { Outlet, Navigate, useSearchParams } from 'react-router-dom';

import { lazyWithRetry } from 'src/utils/lazy-with-retry';

import PreAuthVersionGuard from 'src/auth/guard/pre-auth-version-guard';

import { SplashScreen } from 'src/components/loading-screen';
import { ChunkErrorBoundary } from 'src/components/error-boundary/ChunkErrorBoundary';

import { usePointPaySession } from './session-context';
import { pointPayReturnPath } from './session-identity';

const LoginPage = lazyWithRetry(() => import('src/pages/auth/pointpay-login'));

function PointPayLoginRoute() {
  const session = usePointPaySession();
  const [params] = useSearchParams();
  if (session) return <Navigate replace to={pointPayReturnPath(params.get('returnTo'))} />;
  return (
    <PreAuthVersionGuard>
      <LoginPage />
    </PreAuthVersionGuard>
  );
}

function LegacyLoginRedirect() {
  const [params] = useSearchParams();
  const search = new URLSearchParams({ returnTo: pointPayReturnPath(params.get('returnTo')) });
  return <Navigate replace to={`/auth/login?${search}`} />;
}

export const pointPayAuthRoutes = [
  {
    path: 'auth',
    element: (
      <ChunkErrorBoundary>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </ChunkErrorBoundary>
    ),
    children: [
      { path: 'login', element: <PointPayLoginRoute /> },
      { path: 'login-companion', element: <LegacyLoginRedirect /> },
      { path: 'v3-device-login', element: <LegacyLoginRedirect /> },
    ],
  },
];
